import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[streetAddressVallidation]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: StreetAddressDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class StreetAddressDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    
   return /^(?![<\s.>])(?!.*[<\s>]$)[a-zA-ZÀ-ÿčęàâæéêèëïîôœûùç0-9#.\s]+(?:[-_:%&#,/\\()'`\u2122.+][a-zA-ZÀ-ÿčęàâæéêèëïîôœûùç0-9.)\s]+)*$/.test(control.value)
     ? null
     : { invalid : true };
 };
}
